import { render } from "./fb-info.vue?vue&type=template&id=92a7c344&scoped=true"
import script from "./fb-info.vue?vue&type=script&lang=js"
export * from "./fb-info.vue?vue&type=script&lang=js"

import "./fb-info.vue?vue&type=style&index=0&id=92a7c344&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Rhtm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a7c344"]])

export default __exports__